import React from 'react'
import PropTypes from 'prop-types'
import VsDateRangePicker from '../../common/components/date_picker/vs_date_range_picker'
import './date_select_component.scss'

export default class DateSelect extends React.Component {
  constructor (props) {
    super(props)

    this.handleChangeDates = this.handleChangeDates.bind(this)
  }

  handleChangeDates({ startDate, endDate }) {
    const formatStr = 'YYYY-MM-DD'
    const state = {}
    state['checkin'] = startDate ? startDate.format(formatStr) : undefined
    state['checkout'] = endDate ? endDate.format(formatStr) : undefined
    this.props.onUpdate(state)
  }

  render() {
    return (
      <VsDateRangePicker
        virtical={this.props.virtical}
        onDatesChange={this.handleChangeDates}
        onFocusChange={this.props.onFocusChange}
        startDate={this.props.checkin || null}
        endDate={this.props.checkout || null}
        lang={this.props.lang}
        startDatePlaceholderText={this.props.startDatePlaceholderText}
        endDatePlaceholderText={this.props.endDatePlaceholderText}
        displayFormat={this.props.displayFormat}
      />
    )
  }
}

DateSelect.propTypes = {
  virtical: PropTypes.bool,
  checkin: PropTypes.string,
  checkout: PropTypes.string,
  onUpdate: PropTypes.func.isRequired,
  onFocusChange: PropTypes.func,
  lang: PropTypes.string.isRequired,
  startDatePlaceholderText: PropTypes.string.isRequired,
  endDatePlaceholderText: PropTypes.string.isRequired,
  displayFormat: PropTypes.string.isRequired
}

DateSelect.defaultProps = {
  onUpdate: () => {},
  onFocusChange: () => {},
  lang: 'ja'
}
